/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class FormatAPI {

  /**
   * Method that creates a new format
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiFormat(
    requestBody: {
      id?: number;
      width: number;
      height: number;
      orientation?: 'vertical' | 'horizontal' | 'both' | null;
      text_slot?: number;
      allow_text?: boolean;
      allow_image?: boolean;
      allow_flash?: boolean;
      active?: boolean;
      stripped_name?: string | null;
      name?: string | null;
      order?: number | null;
      allow_as_media?: boolean;
      allow_publisher?: boolean;
      is_public?: boolean;
      extend_format_id?: number | null;
      native_template?: string | null;
      is_admin_dsp?: boolean;
    },
  ): CancelablePromise<{
    id: number;
    width: number;
    height: number;
    orientation: 'vertical' | 'horizontal' | 'both' | null;
    text_slot: number;
    allow_text: boolean;
    allow_image: boolean;
    allow_flash: boolean;
    active: boolean;
    stripped_name: string | null;
    name: string | null;
    order: number | null;
    allow_as_media: boolean;
    allow_publisher: boolean;
    is_public: boolean;
    extend_format_id: number | null;
    native_template: string | null;
    is_admin_dsp: boolean;
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/format',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that updates a particular format
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static putApiFormat(
    requestBody: {
      id: number;
      width?: number;
      height?: number;
      orientation?: 'vertical' | 'horizontal' | 'both' | null;
      text_slot?: number;
      allow_text?: boolean;
      allow_image?: boolean;
      allow_flash?: boolean;
      active?: boolean;
      stripped_name?: string | null;
      name?: string | null;
      order?: number | null;
      allow_as_media?: boolean;
      allow_publisher?: boolean;
      is_public?: boolean;
      extend_format_id?: number | null;
      native_template?: string | null;
      is_admin_dsp?: boolean;
    },
  ): CancelablePromise<{
    id: number;
    width: number;
    height: number;
    orientation: 'vertical' | 'horizontal' | 'both' | null;
    text_slot: number;
    allow_text: boolean;
    allow_image: boolean;
    allow_flash: boolean;
    active: boolean;
    stripped_name: string | null;
    name: string | null;
    order: number | null;
    allow_as_media: boolean;
    allow_publisher: boolean;
    is_public: boolean;
    extend_format_id: number | null;
    native_template: string | null;
    is_admin_dsp: boolean;
  }> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/format',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that deletes a particular format
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static deleteApiFormat(
    id: number,
  ): CancelablePromise<{
    id: number;
    width: number;
    height: number;
    orientation: 'vertical' | 'horizontal' | 'both' | null;
    text_slot: number;
    allow_text: boolean;
    allow_image: boolean;
    allow_flash: boolean;
    active: boolean;
    stripped_name: string | null;
    name: string | null;
    order: number | null;
    allow_as_media: boolean;
    allow_publisher: boolean;
    is_public: boolean;
    extend_format_id: number | null;
    native_template: string | null;
    is_admin_dsp: boolean;
  }> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/format/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that returns a particular format
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiFormat(
    id: number,
  ): CancelablePromise<{
    id: number;
    width: number;
    height: number;
    orientation: 'vertical' | 'horizontal' | 'both' | null;
    text_slot: number;
    allow_text: boolean;
    allow_image: boolean;
    allow_flash: boolean;
    active: boolean;
    stripped_name: string | null;
    name: string | null;
    order: number | null;
    allow_as_media: boolean;
    allow_publisher: boolean;
    is_public: boolean;
    extend_format_id: number | null;
    native_template: string | null;
    is_admin_dsp: boolean;
  } | null> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/format/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that returns a list of media/zone formats
   * @param offset
   * @param limit
   * @param search
   * @param match
   * @param orderby
   * @param comparator
   * @param active
   * @param isPublic
   * @param isAdminDsp
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiFormatList(
    offset?: number,
    limit?: number,
    search?: string,
    match: 'exact' | 'contains' | 'starts_with' | 'ends_with' | 'not' = 'starts_with',
    orderby?: Array<string>,
    comparator?: Array<string>,
    active?: boolean,
    isPublic?: boolean,
    isAdminDsp?: boolean,
  ): CancelablePromise<Array<{
    id: number;
    width: number;
    height: number;
    orientation: 'vertical' | 'horizontal' | 'both' | null;
    text_slot: number;
    allow_text: boolean;
    allow_image: boolean;
    allow_flash: boolean;
    active: boolean;
    stripped_name: string | null;
    name: string | null;
    order: number | null;
    allow_as_media: boolean;
    allow_publisher: boolean;
    is_public: boolean;
    extend_format_id: number | null;
    native_template: string | null;
    is_admin_dsp: boolean;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/format/list',
      query: {
        'offset': offset,
        'limit': limit,
        'search': search,
        'match': match,
        'orderby': orderby,
        'comparator': comparator,
        'active': active,
        'is_public': isPublic,
        'is_admin_dsp': isAdminDsp,
      },
    });
  }

}
